import { render, staticRenderFns } from "./TemplateUpdateNormal.vue?vue&type=template&id=5754dffb&scoped=true&"
import script from "./TemplateUpdateNormal.vue?vue&type=script&lang=js&"
export * from "./TemplateUpdateNormal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateUpdateNormal.vue?vue&type=style&index=0&id=5754dffb&scoped=true&lang=css&"
import style1 from "./TemplateUpdateNormal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5754dffb",
  null
  
)

export default component.exports